    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header" [ngClass]="!header ? 'no-header' : ''">
        <div class="row" *ngIf="header">
          <div class="col-12 text-center">
            <label>{{header}}</label>
          </div>
        </div>
        <button type="button" class="close" (click)="dismiss()">
          <img title="Close" src="https://s3-ap-southeast-1.amazonaws.com/finanma-static/assets/images/icon/close.png">
        </button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="row justify-content-center confirm-title">
          <div class="col-12" *ngIf="!config.noIcon">
              <!-- <div class="img-message" style="margin-bottom: 10px">
                  <img [src]="Constant.url_asset + '/assets/images/icon/notice.png'">
                </div> -->
                <div class="f-modal-alert">
                    <div class="f-modal-icon f-modal-warning scaleWarning">
                        <span class="f-modal-body pulseWarningIns"></span>
                        <span class="f-modal-dot pulseWarningIns"></span>
                      </div>
                </div>
          </div>
          <div class="col-12">
            <h5><strong>{{title}}</strong></h5>
          </div>
         
        </div>
      </div>
      <div class="modal-footer">
        <div class="container-fluid col-md-12 footer-button">
          <div class="row">
            <div class="col-6">
              <button class="btn btn-cancel btn--trans" (click)="cancel()">
                {{buttonCancelLabel}}</button>
            </div>
            <div class="col-6">
              <button class="btn btn-buy btn--green" type="button" (click)="argree()">
                {{buttonLabel}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
